import i18n from "i18next";

// Формат зависит от активной локали (ru «в прошлом месяце» / en «last month»),
// а не пришит к "en". Кэшируем по языку — Intl.RelativeTimeFormat недёшев в конструкции.
const relativeTimeFmtCache = new Map<string, Intl.RelativeTimeFormat>();

function relativeTimeFmt(lang: string): Intl.RelativeTimeFormat {
    let fmt = relativeTimeFmtCache.get(lang);
    if (fmt === undefined) {
        fmt = new Intl.RelativeTimeFormat(lang, { numeric: "auto" });
        relativeTimeFmtCache.set(lang, fmt);
    }
    return fmt;
}

export function fmtRelative(iso: string | null | undefined, lang: string = i18n.language || "en"): string {
    if (!iso) return "—";
    const ts = Date.parse(iso);
    if (Number.isNaN(ts)) return "—";
    const diff = (Date.now() - ts) / 1000;
    const abs = Math.abs(diff);
    const fmt = relativeTimeFmt(lang);
    if (abs < 60) return fmt.format(-Math.round(diff), "second");
    if (abs < 3600) return fmt.format(-Math.round(diff / 60), "minute");
    if (abs < 86400) return fmt.format(-Math.round(diff / 3600), "hour");
    if (abs < 30 * 86400) return fmt.format(-Math.round(diff / 86400), "day");
    if (abs < 365 * 86400) return fmt.format(-Math.round(diff / (30 * 86400)), "month");
    return fmt.format(-Math.round(diff / (365 * 86400)), "year");
}

export function fmtFileSize(bytes: number | null | undefined): string {
    if (bytes === null || bytes === undefined || Number.isNaN(bytes)) return "—";
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
    return `${(bytes / (1024 * 1024 * 1024)).toFixed(1)} GB`;
}
